//import 'jquery';
import { Color } from './color';
export { Color };
export class Colors {
    constructor(brandedColors, colorScheme) {
        if (typeof brandedColors === 'undefined') {
            this.setBrandedColors([
                [[0, 0, 0]], [[77, 77, 77]], [[113, 113, 113]], [[143, 143, 143]], [[170, 170, 170]], [[195, 195, 195]]
            ]);
        } else {
            this.setBrandedColors(brandedColors);
        }

        if (typeof colorScheme !== 'undefined' && colorScheme !== null) {
            this.accent = new Color({ rgb: colorScheme.accent, name: 'accent' });
            this.background = new Color({ rgb: colorScheme.background, name: 'background' });
            this.backgroundAlternate = new Color({ rgb: colorScheme.backgroundAlternate, name: 'backgroundAlternate' });
            this.backgroundDark = new Color({ rgb: colorScheme.backgroundDark, name: 'backgroundDark' });
            this.backgroundHighlight = new Color({ rgb: colorScheme.backgroundHighlight, name: 'backgroundHighlight' });
            this.border = new Color({ rgb: colorScheme.border, name: 'border' });
            this.borderLight = new Color({ rgb: colorScheme.borderLight, name: 'borderLight' });
            this.borderDark = new Color({ rgb: colorScheme.borderDark, name: 'borderDark' });
            this.chartColor1 = new Color({ rgb: colorScheme.chartColor1, name: 'chartColor1' });
            this.chartColor2 = new Color({ rgb: colorScheme.chartColor2, name: 'chartColor2' });
            this.chartColor3 = new Color({ rgb: colorScheme.chartColor3, name: 'chartColor3' });
            this.chartColor4 = new Color({ rgb: colorScheme.chartColor4, name: 'chartColor4' });
            this.chartColor5 = new Color({ rgb: colorScheme.chartColor5, name: 'chartColor5' });
            this.chartColor6 = new Color({ rgb: colorScheme.chartColor6, name: 'chartColor6' });
            this.danger = new Color({ rgb: colorScheme.danger, name: 'danger' });
            this.primary = new Color({ rgb: colorScheme.primary, name: 'primary' });
            this.primaryDarker = new Color({ rgb: colorScheme.primaryDarker, name: 'primaryDarker' });
            this.primaryLighter = new Color({ rgb: colorScheme.primaryLighter, name: 'primaryLighter' });
            this.success = new Color({ rgb: colorScheme.success, name: 'success' });
            this.text = new Color({ rgb: colorScheme.text, name: 'text' });
            this.textLight = new Color({ rgb: colorScheme.textLight, name: 'textLight' });
            this.warning = new Color({ rgb: colorScheme.warning, name: 'warning' });
        }

        this.MIN_COLORS_PER_GROUP = 4;
        this.numColorsPerGroup = Number.MAX_VALUE;
        this.groups = [];
        this.initializeColors();
    }

    setBrandedColors(colors) {
        this.brandedColors = colors;
    }

    /**
    * Generates the array of color objects,
    * automatic tinted color generation included.
    */
    initializeColors() {
        this.groups = [];
        this._numColorsPerGroup = this._getNumColorsPerGroup();
        for (var i = 0, nr = this.brandedColors.length; i < nr; i++) {
            var colorGroupId = i;
            var colorGroupValues = this.brandedColors[i];
            this.groups[colorGroupId] = this._createColorGroup(colorGroupId, colorGroupValues);
        }
    }

    /**
    * getColorByName returns the color by its name from the allColors array, or color groups array.
    * @param {int|string} name the number a color has
    * @return {string} Color|undefined, undefined if a color with given name did not exist
    */
    getColorByName(name) {
        if (typeof name === 'number') {
            name = name + '';
            name = name.length < 2 ? '0' + name : '' + name;
        }

        // groups created in colorsnew.ts
        for (var k = 0, nrGroups = this.groups.length; k < nrGroups; k++) {
            var group = this.groups[k];
            for (var j = 0, groupLength = group.length; j < groupLength; j++) {
                var color2 = group[j];
                if (color2.name === name) {
                    return color2;
                }
            }
        }

        return undefined;
    }

    /**
    * Adds the function toHexArray to the passed object.
    * @param {object} object a colors object of this class representing a color
    */
    addToHexArray(object) {
        object.toHexArray = function () {
            return this.map(function (a) { return a.hex; });
        };
    }

    /**
    * Adds the function toRgbArray to the passed object.
    * @param {object} object a colors object of this class representing a color
    */
    addToRgbArray(object) {
        object.toRgbArray = function () {
            return this.map(function (a) { return 'rgb(' + a.rgb.replace(/ /g, ',') + ')'; });
        };
    }

    /**
    * Gets the specified amount of unique colors, picked from as few groups as possible,
    * and as evenly distributed among the groups as possible.
    * @returns {[object]} colors object with added functions toHexArray and toRgbArray
    * @param {number} numColors number colors to return which is of Harmonious type
    */
    getHarmonious(numColors) {
        var numGroups = Math.ceil(numColors / this._numColorsPerGroup);
        var numColorsPerGroup = numColors / numGroups;
        var numColorsPerGroupInteger = Math.floor(numColors / numGroups);
        var numColorsPerGroupFraction = numColorsPerGroup - numColorsPerGroupInteger;
        var numColorsPerGroupRemainder = Math.round(numColorsPerGroupFraction * numGroups);

        var colors = [];

        for (var numAdded = 0, groupIdx = 0; numAdded < numColors; groupIdx++) {
            /* start from the first group again if we run out of color groups */
            groupIdx = groupIdx > this.groups.length - 1 ? 0 : groupIdx;

            var j = 0;
            for (; j < numColorsPerGroupInteger; j++) {
                colors.push(this.groups[groupIdx][j]);
                numAdded++;
            }
            if (numColorsPerGroupRemainder > 0) {
                colors.push(this.groups[groupIdx][j]);

                numColorsPerGroupRemainder--;
                numAdded++;
            }
        }
        this.addToHexArray(colors);
        this.addToRgbArray(colors);
        return colors;
    }

    /**
    * Gets the specified amount of colors, picked from as many groups as possible.
    * @returns {[object]} colors object with added functions toHexArray and toRgbArray
    * @param {number} numColors number colors to return which is of Harmonious type
    */
    getContrasting(numColors) {
        var colors = [];
        for (var count = 0, group = 0, index = 0;
            count < numColors;
            count++ ,
            group = ++group >= this.groups.length ? 0 : group) {

            if (count > 0 && group === 0) {
                index = index + 1 >= this._numColorsPerGroup ? 0 : index + 1;
            }

            colors.push(this.groups[group][index]);
        }
        this.addToHexArray(colors);
        this.addToRgbArray(colors);
        return colors;
    }

    /**
     * Source: http://stackoverflow.com/a/5624139,  22/5/2017
     * @returns {number} the hex value of given rgb value
     * @param {object} c a rgb component (an array with 3 numbers [RNUM, GNUM, BNUM])
     */
    rgbComponentToHex(c) {
        var hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }

    /** Source: http://stackoverflow.com/a/5624139,  22/5/2017
    * @returns {string} the hex value of given rgb array
    * @param {object} rgb an array of numbers ([RNUM, GNUM, BNUM])
    */
    rgbToHex(rgb) {
        return "#" + this.rgbComponentToHex(Math.round(rgb[0])) +
            this.rgbComponentToHex(Math.round(rgb[1])) +
            this.rgbComponentToHex(Math.round(rgb[2]));
    }

    /** Source: http://stackoverflow.com/a/11508164,  22/5/2017
    * @returns {string} the rgb value of given hex value
    * @param {string} hex a string in hex format
    */
    hexToRgb(hex) {
        var bigint = parseInt(hex, 16);
        var r = (bigint >> 16) & 255;
        var g = (bigint >> 8) & 255;
        var b = bigint & 255;

        return r + "," + g + "," + b;
    }

    /**
     * tintRgb tints (lighten) the given rgb color value
     * @param {object} rgb a rgb array [NUM1, NUM2, NUM3] where num is 0-255
     * @param {number} tintFactor value between 0 and 1, where 1 makes black white
     * @returns {number} the number of colors a color groups should have
     */
    tintRgb(rgb, tintFactor) {
        var rgbTint = [];
        var r = rgb[0] + (255 - rgb[0]) * tintFactor;
        var g = rgb[1] + (255 - rgb[1]) * tintFactor;
        var b = rgb[2] + (255 - rgb[2]) * tintFactor;
        r = r > 255 ? 255 : r;
        g = g > 255 ? 255 : g;
        b = b > 255 ? 255 : b;
        rgbTint.push(r);
        rgbTint.push(g);
        rgbTint.push(b);

        return rgbTint;
    }

    /**
     * Return the size of the smallest group in brandedColors if that groups size
     * is larger than the minimum colors per group.
     * Otherwise return the minimum colors per group.
     * @returns {number} the number of colors a color groups should have
     */
    _getNumColorsPerGroup() {
        var numColorsPerGroup = Number.MAX_VALUE;
        for (var i = 0; i < this.brandedColors.length; i++) {
            var group = this.brandedColors[i];

            if (group.length <= this.MIN_COLORS_PER_GROUP) {
                numColorsPerGroup = this.MIN_COLORS_PER_GROUP;
                break;
            } else if (group.length < numColorsPerGroup) {
                numColorsPerGroup = group.length;
            }
        }

        return numColorsPerGroup === Number.MAX_VALUE ? this.MIN_COLORS_PER_GROUP : numColorsPerGroup;
    }

    _createColorGroup(id, values) {
        var colorGroup = [];

        if (values.length < this._numColorsPerGroup) {

            // fill out the color group with automatically generated tinted versions of the first color
            var tintDistance = 1 / (this._numColorsPerGroup + 1); // 1/(4 + 1) = 0.2

            colorGroup.push(this._getColor(id + '0', values[0] ? values[0] : [0, 0, 0]));

            for (var j = 1; j < this._numColorsPerGroup; j++) {

                var tintedRgb = this.tintRgb(values[0], (j + 1) * tintDistance);
                colorGroup.push(this._getColor(id + '' + j, tintedRgb));
            }
        } else {
            for (var i = 0; i < this._numColorsPerGroup; i++) {
                colorGroup.push(this._getColor(id + '' + i, values[i] ? values[i] : [0, 0, 0]));
            }
        }

        return colorGroup;
    }

    _getColor(name, rgbArr) {
        return new Color({ rgb: rgbArr, name: name });
    }
}